__turbopack_context__.v({
  "chevronIconWrapper": "modalNavWrapper-module-scss-module__e8uiza__chevronIconWrapper",
  "modalNavWrapper": "modalNavWrapper-module-scss-module__e8uiza__modalNavWrapper",
  "modalNavigation": "modalNavWrapper-module-scss-module__e8uiza__modalNavigation",
});
